import { lazy, Suspense, useMemo } from 'react'
import { ErrorBoundary } from '@sentry/react'
import { ErrorFallback } from '../../patterns'
import { DHSManualUpdateLoading } from './DHSManualUpdate.loading'
import { DHSManualUpdateProps } from './DHSManualUpdate.types'
import { addTranslationResources } from './DHSManualUpdate.translations'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '../FeatureFlag/FeatureFlagsProvider'

export const DHSManualUpdateLoadable = lazy(() => import('./DHSManualUpdate'))

type WrapperProps = Omit<DHSManualUpdateProps, 'i18next' | 'useTranslation'> & {
  i18next?: typeof i18next
}

export const DHSManualUpdateWrapper = (props: WrapperProps) => {
  const useTranslationFn = useTranslation
  const i18nInstance = props.i18next || i18next
  const dhsEnabled = useFeatureFlag('FEATURE_DHS_INTEGRATION')
  const { user } = props

  useMemo(() => {
    addTranslationResources(i18nInstance)
  }, [i18nInstance])

  if (!dhsEnabled || !user?.permissions?.createManualDhsApproval) return null

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<DHSManualUpdateLoading />}>
        <DHSManualUpdateLoadable
          {...(props as DHSManualUpdateProps)}
          i18next={i18nInstance}
          useTranslation={useTranslationFn}
        />
      </Suspense>
    </ErrorBoundary>
  )
}

export * from './DHSManualUpdate.types'
export { DHSManualUpdateWrapper as PendingActions }
